// @generated by protobuf-ts 2.9.6 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/extension/seller_profession.proto" (package "bianka.event.activity.v2.extension", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Model } from "../../../../core/enrichment/model";
import { User } from "../../../../core/enrichment/user";
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.SellerProfession
 */
export interface SellerProfession {
    /**
     * The seller profession/role
     *
     * @generated from protobuf field: optional bianka.event.activity.v2.extension.SellerProfession.Profession profession = 1;
     */
    profession?: SellerProfession_Profession;
    /**
     * The seller profession variant
     * Profession can have several variants where each variant repsesents more specific version of that profession
     * Example:
     * ** Profession: "SEO specialists"
     * ** Variations: "Yahoo SEO specialist", "Bing SEO specialist"
     *
     * @generated from protobuf field: optional bianka.event.activity.v2.extension.SellerProfession.Variant variant = 2;
     */
    variant?: SellerProfession_Variant;
    /**
     * The title that is calculated based on the seller's profession and variant
     *
     * @generated from protobuf field: optional string computed_title = 3;
     */
    computedTitle?: string;
    /**
     * The page name where the event was originated from
     *
     * @generated from protobuf field: string page_name = 4;
     */
    pageName: string;
    /**
     * The seller whose page was visited
     *
     * @generated from protobuf field: optional bianka.core.enrichment.User seller = 5;
     */
    seller?: User;
    /**
     * Model id
     *
     * @generated from protobuf field: optional bianka.core.enrichment.Model model = 7;
     */
    model?: Model;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.SellerProfession.Profession
 */
export interface SellerProfession_Profession {
    /**
     * The profession/role id [by product definition]
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The sellerRole id (nested under role) [by product definition]
     *
     * @generated from protobuf field: string seller_profession_id = 2;
     */
    sellerProfessionId: string;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.SellerProfession.Variant
 */
export interface SellerProfession_Variant {
    /**
     * The variant id
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The variant type
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.SellerProfession.VariantType type = 2;
     */
    type: SellerProfession_VariantType;
}
/**
 * @generated from protobuf enum bianka.event.activity.v2.extension.SellerProfession.VariantType
 */
export enum SellerProfession_VariantType {
    /**
     * @generated from protobuf enum value: VARIANT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: VARIANT_TYPE_MD = 1;
     */
    MD = 1,
    /**
     * @generated from protobuf enum value: VARIANT_TYPE_ROLE = 2;
     */
    ROLE = 2,
    /**
     * @generated from protobuf enum value: VARIANT_TYPE_SERVICE = 3;
     */
    SERVICE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class SellerProfession$Type extends MessageType<SellerProfession> {
    constructor() {
        super("bianka.event.activity.v2.extension.SellerProfession", [
            { no: 1, name: "profession", kind: "message", T: () => SellerProfession_Profession },
            { no: 2, name: "variant", kind: "message", T: () => SellerProfession_Variant },
            { no: 3, name: "computed_title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "page_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "seller", kind: "message", T: () => User },
            { no: 7, name: "model", kind: "message", T: () => Model }
        ], { "bianka.core.extension.enrichment": { groupName: "event_ng" } });
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.SellerProfession
 */
export const SellerProfession = new SellerProfession$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SellerProfession_Profession$Type extends MessageType<SellerProfession_Profession> {
    constructor() {
        super("bianka.event.activity.v2.extension.SellerProfession.Profession", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "seller_profession_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.SellerProfession.Profession
 */
export const SellerProfession_Profession = new SellerProfession_Profession$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SellerProfession_Variant$Type extends MessageType<SellerProfession_Variant> {
    constructor() {
        super("bianka.event.activity.v2.extension.SellerProfession.Variant", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["bianka.event.activity.v2.extension.SellerProfession.VariantType", SellerProfession_VariantType, "VARIANT_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.SellerProfession.Variant
 */
export const SellerProfession_Variant = new SellerProfession_Variant$Type();
